namespace $.$$ {
	$mol_style_define($bog_blitz_lobby_game_timer, {
		width: '100%',
		height: '0.35rem',
		margin: { bottom: '1.5rem' },
		Bar: {
			height: '100%',
			background: {
				color: $mol_theme.special,
			},
		},
	})
}
